import { useTranslation } from 'react-i18next'
import { VpLink } from '@vtmn-play/react'
import { trackEvent } from '@/src/analytics/amplitude'

const ReportBug = () => {
  const { t } = useTranslation('common')
  return (
    <VpLink
      href="https://support.decathlon.net/saw/ess/offeringPage/217963195"
      target="_blank"
      className="flex justify-between items-center py-3 text-gray-900"
      rel="noreferrer"
      onClick={() => trackEvent('REPORT_BUG_BUTTON_CLICK')}
    >
      <div>
        <p className="font-medium">{t('components.actions.report-bug')}</p>
        <p className="text-sm text-gray-500">{t('components.actions.report-bug-description')}</p>
      </div>
      <img src="/icons/chevron.svg" width={24} height={24} alt="right chevron" />
    </VpLink>
  )
}

export default ReportBug
